<template>
    <div class="inner_box">
            <div class="inner_box_content">
                <div v-if="hide === false">
                    <div class="video-iframe-container" @click="playVid">
                        <div class="video-iframe-content">
                            <h1 class="video-iframe-headline">{{card.headline}}</h1>
                            <div v-if="!play" class="video-iframe-control">
                                <md-icon class="control_icon md-size-2x">play_arrow</md-icon>
                            </div>
                        </div>
                        <div class="video-element-container">
                            <visual :video="card.video_url"
                                    ref='visual'
                                    class="video-iframe-video"
                                    loop
                                    fill>
                            </visual>
                        </div>
                        <div class="video-iframe-bg" :style='{ backgroundImage: `url("${card.thumb}")` }'></div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    import bus from '../bus'

    export default {
        name: "card",
        props: ['card','hide', 'disableSwipe'],
        data() {
            return {
                play: false
            }
        },
        methods: {
            playVid() {
                if (this.play === true) {
                    this.play = false;
                    this.$refs.visual.pause();
                } else {
                    this.play = true;
                    this.$refs.visual.play();
                }
            }
        },
        mounted() {
            bus.$on('pause', (p) => {
                this.play = false;
                this.$refs.visual.pause();
            });
        }
    }
</script>

<style scoped>
    .inner_box {
        align-items: center;
        background-color: #f5f5f5;
        min-width: 100vw;
        height: 100%;
        overflow-x: hidden;
    }

    .video-iframe-container {
        position: relative;
        width: 100%;
        height: calc(81vh - 48px);
    }

    .video-iframe-content {
        position: relative;
        bottom: 0;
        margin-left: 18px;
        margin-right: 18px;
        height: 100%;
        z-index: 2;
        font-size: 16px;
        color: #000000;
    }

    .video-iframe-headline {
        position: absolute;
        bottom: 5vh;
        left: 0;
        right: 0;
        font-weight: 500;
        background: rgba(255,255,255,0.86);
        border-radius: 4px;
        padding: 1.8%;
    }

    .video-iframe-control {
        position: absolute;
        top: 36%;
        left: 50%;
        margin-left: -8vh;
        height: 16vh;
        width: 16vh;
        border-radius: 100%;
        background: rgba(0,168,107,0.86);
    }

    .control_icon {
        height: 100% !important;
        color: #ffffff !important;
    }

    .video-iframe-video {
        position: absolute;
        z-index: 1;
        width: 100vw;
        left: 50%;
        top: 34vh;
        transform: translate(-50%, -50%);
    }

    .video-iframe-bg {
        position: absolute;
        top: 0;
        z-index: 0;
        height: 100%;
        width: 100%;
        filter: blur(16px);
        -webkit-filter: blur(32px);
    }
</style>